import { createAction } from 'redux-actions';

import {
  UPDATE_CONVERSATION_START,
  UPDATE_CONVERSATION_DONE,
  UPDATE_CONVERSATION_FAIL,
} from '../constants/Actions';

export default {
  start: createAction(UPDATE_CONVERSATION_START),
  done: createAction(UPDATE_CONVERSATION_DONE),
  fail: createAction(UPDATE_CONVERSATION_FAIL),
};
